<template>
  <div>
    <BrProductFilter @change="handleChange" />
    <BaseCountCardProduct ref="baseCountCardProductRef" :filter-form="filterForm" style="margin-top: 18px" />
    <a-row :gutter="20" style="margin-top: 20px">
      <a-col v-for="(item,idx) in producCountDataList" :key="idx" :span="12" :style="idx>1?'margin-top:20px':''">
        <ProducCount
          :ref="'producCountRef'+idx"
          :filter-form="filterForm"
          :title="item.title"
          :desc="item.desc"
          :data="tableData"
          :filter-func="item.filterFunc"
        />
      </a-col>
    </a-row>
  </div>
</template>

<script>
import BrProductFilter from './components/BrProductFilter.vue';
import BaseCountCardProduct from './components/BaseCountCardProduct.vue';
import ProducCount from './components/ProducCount.vue';
import { getBrProductBaseCollecter } from '@/api/business/requirement';
import moment from 'moment';

export default {
  components: { BrProductFilter, BaseCountCardProduct, ProducCount },
  data() {
    return {
      tableData: [],
      brRetrospectMap: {},
      filterForm: {
        searchTimeType: 135,
        noDesignDay: 5,
        noDevDay: 20,
        po: [],
        startTime: '',
        endTime: ''
      }
    };
  },
  computed: {
    producCountDataList() {
      return [
        {
          title: '个人需求分布',
          desc: '个人需求分布',
          filterFunc: this.filterFunc1
        },
        {
          title: this.filterForm.noDesignDay + '天未设计需求',
          desc: '未设计需求',
          filterFunc: this.filterFunc2
        },
        {
          title: '未评审需求',
          desc: '未评审需求',
          filterFunc: this.filterFunc3
        },
        {
          title: this.filterForm.noDevDay + '天未开发需求',
          desc: '未开发需求',
          filterFunc: this.filterFunc4
        },
        {
          title: '待提交验收需求',
          desc: '待提交验收需求',
          filterFunc: this.filterFunc5
        }
      ];
    }
  },
  created() {
    // this.getRetData();
  },
  methods: {
    filterFunc1(item, userId) {
      // 个人需求分布
      return item.po.includes(userId);
    },
    filterFunc2(item, userId) {
      // 未设计需求
      if (item.stepId !== 135 || !item.po.includes(userId) || item.designStatus === 3 || !item.stepTime) {
        // 已完成
        return false;
      }
      const daysDiff = moment().diff(moment(item.stepTime), 'days');
      return daysDiff > this.filterForm.noDesignDay;
    },
    filterFunc3(item, userId) {
      // 未评审需求
      return item.stepId === 149 && item.po.includes(userId);
    },
    filterFunc4(item, userId) {
      // 未开发需求
      if (item.stepId !== 136 || !item.po.includes(userId) || !item.stepTime) {
        // 已完成
        return false;
      }
      const daysDiff = moment().diff(moment(item.stepTime), 'days');
      return daysDiff > this.filterForm.noDevDay;
    },
    filterFunc5(item, userId) {
      // 待提交验收需求
      if (item.stepId !== 137 || !item.po.includes(userId)) {
        // 已完成
        return false;
      }
      return item.noDoneDevReq > 0;
    },
    handleChange(form) {
      this.filterForm = form;
      this.getRetData();
    },
    getRetData() {
      getBrProductBaseCollecter(this.filterForm).then(res => {
        const _data = res.data || [];
        if (_data) {
          _data.map(item => {
            if (item.po) {
              item.po = JSON.parse(item.po);
            } else {
              item.po = [];
            }
            return item;
          });
        }
        this.tableData = _data;
        // console.log(_data);
        this.$nextTick(() => {
          this.$refs.baseCountCardProductRef.init(_data);
          this.producCountDataList.forEach((item, index) => {
            this.$refs['producCountRef' + index][0].changeData();
          });
        });
      });
    }

  }
};
</script>

<style lang="less" scoped></style>
